export const roundToFloat = (value: string | number, decimals = 3): string => {
  return parseFloat(value.toString()).toFixed(decimals);
};
